export enum Warnings {
  ENFORCE_TIMEOUT = "Enforce Table Assignment transfers took longer than expected",
  FACEBOOK_SSO = "Facebook SSO flow",
  GEARTEST_ADBLOCK_DETECTED = "Geartest AdBlock detected",
  GEARTEST_BROWSER_NOT_SUPPORTED = "Geartest browser not supported",
  GEARTEST_FIREBASE_INACCESSIBLE = "Geartest firebase inaccessible",
  GEARTEST_FIREBASE_STORAGE_INACCESSIBLE = "Geartest firebase storage inaccessible",
  GEARTEST_FIRESTORE_INACCESSIBLE = "Geartest firestore inaccessible",
  GEARTEST_INTERNET_CONNECTION_SLOW = "Geartest internet connection slow",
  GEARTEST_OS_NOT_SUPPORTED = "Geartest OS not supported",
  GEARTEST_OT_CREATE_SESSION_FAILED = "Geartest OT create session failed",
  GEARTEST_OT_INACCESSIBLE = "Geartest openTok inaccessible",
  GEARTEST_VPN_DETECTED = "Geartest VPN detected",
  GOOGLE_SSO = "Google SSO flow",
  LINKEDIN_SSO = "Linkedin SSO flow",
  MS_SSO = "Microsoft SSO flow",
  OT_CONSTRAINTS_NOT_SATISFIED = "OpenTok Constraints Not Satisfied",
  OT_HARDWARE_UNAVAILABLE = "OpenTok Hardware Unavailable",
  OT_STREAM_CONNECTIVITY_ISSUE = "OpenTok Stream Connectivity Issue",
  OT_USER_MEDIA_ACCESS_DENIED = "OpenTok User Media Access Denied",
  SHUFFLE_TIMEOUT = "Shuffle took longer than expected",
  SSO_UNVERIFIED_DOMAIN_REDIRECT = "Attempted to do a SSO redirect to an unverified domain",
  TEST = "only used for unit testing",
}
